const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const PUBLIC_MEDIA_PATH = /^\/api\/v2\/media\/[^/]+$/;

// CMS media have a same-origin proxy; other legacy resources still use the API host.
const absoluteUrl = value => {
  if (!value) return '';
  const url = String(value);
  if (url.startsWith('/') && !url.startsWith('//')) {
    return PUBLIC_MEDIA_PATH.test(url.split(/[?#]/)[0]) ? url : `${BACKEND_URL}${url}`;
  }
  try {
    const parsed = new URL(url);
    if (BACKEND_URL && parsed.origin === new URL(BACKEND_URL).origin && PUBLIC_MEDIA_PATH.test(parsed.pathname)) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return url;
  }
  return url;
};

// Only the CMS media proxy supports width variants; external and other files keep their URLs.
const responsiveImageProps = (value, sizes = '(max-width: 767px) 100vw, 50vw') => {
  if (value === '/images/logo.jpeg') return { srcSet: '/images/logo-64.webp 64w, /images/logo-128.webp 128w, /images/logo-256.webp 256w', sizes };
  const url = absoluteUrl(value);
  if (!url.startsWith('/api/v2/media/') || !PUBLIC_MEDIA_PATH.test(url.split(/[?#]/)[0])) return {};
  const parsed = new URL(url, 'https://justvitalityclinic.com');
  const srcSet = [256, 384, 640, 960, 1280, 1920].map(width => {
    parsed.searchParams.set('w', String(width));
    return `${parsed.pathname}${parsed.search} ${width}w`;
  }).join(', ');
  return { srcSet, sizes };
};

// Use native auto sizes for lazy images with a CSS-defined aspect ratio (treatment cards).
// Keep the existing larger fallback for zoomed crops, whose transform exceeds the layout box.
const lazyImageProps = (value, crop) => responsiveImageProps(value,
  Number(crop?.zoom || 1) > 1 ? undefined : 'auto, (max-width: 767px) 100vw, 50vw');

module.exports = { absoluteUrl, responsiveImageProps, lazyImageProps };
